import { FieldAttributes } from '~/legacy-components/CustomDataFields';
import {
  CommonFormDataToLegacyPayloadProps,
  LegacyProposalRequestProps,
  mapSubmitDataUtils,
  submitLegacyProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';
import { fetchFromOldApi } from '~/services/Http';

import { LegacyProposalAPI } from '../../../data';

import { BillableHoursProposalFormData } from './';

export type BillableHoursSubmitData = {
  fEmplId: number;
  fEmplSubUId?: string;
  fBillableHoursType: string;
  fBillableHoursProjectType: string;
  fBillableHoursAmountForProposal: number;
  fBillableHoursProposalHours: number;
  fBillableHoursProposalTotal: number;
  fBillableHoursProposalPaymentPeriodStartDate: string;
  fBillableHoursProposalPaymentPeriodEndDate: string;
  fBillableHoursProposalPaymentDate: string;
  fBillableHoursProposalManagerId: number;
  fBillableHoursProposalHigherMgrId: number;
  fBillableHoursProposalHrId: number;
  fBillableHoursProposalStatus: string;
  fBillableHoursProposalCustomFields?: unknown; // ???
  fBillableHoursProposalInfo: string;
};

export const mapFormDataToLegacyPayload = (
  props: CommonFormDataToLegacyPayloadProps<BillableHoursProposalFormData>,
): BillableHoursSubmitData => {
  const {
    data,
    isHRUser,
    decision,
    requestProps: { employeeId, proposalId },
  } = props;
  const {
    submissionResponsibleHR,
    submissionDateInFormat,
    submissionProposalStatus,
  } = mapSubmitDataUtils({ defaultSubmissionDateFormat: 'YYYY-MM-DD' });

  return {
    fEmplId: +data?.employmentId || employeeId,
    fEmplSubUId: proposalId,
    fBillableHoursAmountForProposal: data.hours || 0,
    fBillableHoursType: data.hoursType || '',
    fBillableHoursProjectType: data.projectType || '',
    fBillableHoursProposalHours: data.hours || 0,
    fBillableHoursProposalTotal: data.total || 0,
    fBillableHoursProposalPaymentPeriodStartDate: submissionDateInFormat(
      data.paymentPeriodStartDate,
    ),
    fBillableHoursProposalPaymentPeriodEndDate: submissionDateInFormat(
      data.paymentPeriodEndDate,
    ),
    fBillableHoursProposalPaymentDate: submissionDateInFormat(data.paymentDate),
    fBillableHoursProposalManagerId: -1,
    fBillableHoursProposalHigherMgrId: -1,
    fBillableHoursProposalHrId: submissionResponsibleHR(data.responsibleHR),
    fBillableHoursProposalStatus: submissionProposalStatus({
      isHRUser,
      decision,
    }),
    fBillableHoursProposalInfo: data.info || '',
    fBillableHoursProposalCustomFields:
      data.fBillableHoursProposalCustomFields || {},
  };
};

export const submitBillableHoursProposal = async (
  data: BillableHoursSubmitData,
  requestProps: LegacyProposalRequestProps,
) =>
  submitLegacyProposal<BillableHoursSubmitData>(
    LegacyProposalAPI.BillableHoursProposal,
    data,
    requestProps,
  );

export const getCustomBillableHoursFieldAttributes = (): Promise<
  FieldAttributes[]
> => {
  return fetchFromOldApi(
    `/json/customdata/entity/BILLABLE_HOURS_PROPOSAL/attribute`,
  ).then((r) => r.json());
};
